/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxCurrencyModule } from 'ngx-currency';
import { SharedDirectivesModule } from './directives/directives.modules';
import { SharedPipeModule } from './pipes/pipes.modules';
import { SharedToolkitModule } from './toolkit/toolkit.module';

@NgModule({
    imports: [
        CommonModule,
        SharedPipeModule,
        SharedToolkitModule,
        SharedDirectivesModule,
        NgxCurrencyModule
    ],
    exports: [
        SharedPipeModule,
        SharedToolkitModule,
        SharedDirectivesModule,
        NgxCurrencyModule
    ]
})
export class SharedModule { }
